export const CAT_MAP = {
  // positivos
  'ambiente de trabajo': {
    key: 'ambiente',
    title: 'Nivel de riesgo del ambiente laboral',
    bucket: 'positive',
  },
  'liderazgo y relaciones en el trabajo': {
    key: 'liderazgo',
    title: 'Nivel de riesgo de liderazgo y relaciones laborales',
    bucket: 'positive',
  },
  'entorno organizacional': {
    key: 'entorno',
    title: 'Nivel de riesgo del entorno organizacional',
    bucket: 'positive',
  },

  // negativos
  'organizacion del tiempo de trabajo': {
    key: 'tiempo',
    title: 'Nivel de riesgo de organización del tiempo de trabajo',
    bucket: 'negative',
  },
  'interferencia en la relacion trabajo familia': {
    key: 'familia',
    title: 'Nivel de riesgo de relación familia y trabajo',
    bucket: 'negative',
  },
  'factores propios de la actividad': {
    key: 'actividad',
    title: 'Nivel de riesgo de factores propios de la actividad',
    bucket: 'negative',
  },
} as const;

type CatKey = keyof typeof CAT_MAP;
